export default Object.freeze({
  Home: 1,
  Login: 2,
  Tasks: 3,
  CompanySelector: 4,
  EnvironmentSelector: 5,
  Processes: 6,
  Lists: 7,
  // EntityData: 8,
  ProcessInstanceDetails: 9,
  BulkRequests: 10,
});
